import buildCanonicalUrl from '~/utils/buildCanonicalUrl';

const storyblokOgImage = (
    url: string | undefined,
    width: number,
    height: number,
): string | undefined => {
    if (!url) return undefined;
    return `${url}/m/fit-in/${width}x${height}/filters:fill(transparent):format(webp):quality(90)`;
};

export default (story: any) => {
    const metaTags = story.content.SEOMetatags;
    const canonical = story.content.canonical;
    const storySlug = story.full_slug !== 'home' ? '/' + story.full_slug : '';
    const pageType =
        story.content.component === 'article' ? 'article' : 'website';
    const pageQuery: any = useRoute().query?.page;

    const canonicalUrl = buildCanonicalUrl({
        baseUrl: useRuntimeConfig().public.baseUrl,
        storySlug,
        canonicalStoryblokLink: canonical,
        pageQuery,
    });

    useServerHead({
        link: [
            {
                rel: 'canonical',
                href: canonicalUrl,
            },
        ],
    });

    if (metaTags) {
        useSeoMeta({
            title: metaTags.title,
            description: metaTags.description,
            ogTitle: metaTags.og_title,
            ogType: pageType,
            ogDescription: metaTags.og_description,
            ogImage: storyblokOgImage(metaTags.og_image, 1200, 630),
            ogUrl: canonicalUrl,
            twitterTitle: metaTags.twitter_title,
            twitterDescription: metaTags.twitter_description,
            twitterImage: storyblokOgImage(metaTags.twitter_image, 1200, 630),
        });
    }

    if (story.content.robots_noindex !== false) {
        useSeoMeta({
            robots: {
                noindex: story.content.robots_noindex,
                nofollow: story.content.robots_noindex,
            },
        });
    }

    if (!metaTags || metaTags.title === '') {
        useHead({
            title: 'Roastar | ' + story.name,
        });
    }
};
